import { useEffect, useCallback } from 'react';
import { useApiGet, useApiLoading } from 'react-reqq-lite';
import * as actions from './actions';
import * as c from './constants';

export const useGetUserList = (params) => {
  const isLoading = useApiLoading(c.ACL_BILLER_LIST, 'get');
  const data = useApiGet(c.ACL_BILLER_LIST, []);
  const pager = useApiGet(c.ACL_PAGER, {});
  useEffect(() => {
    actions.getUserList(params);
  }, [params]);
  return [data, isLoading, pager];
};

export const useGetBillerOptions = () => {
  const isLoading = useApiLoading(c.ACL_BILLER_OPTIONS, 'get');
  const data = useApiGet(c.ACL_BILLER_OPTIONS, []);
  useEffect(() => {
    actions.getBillerOptions();
  }, []);
  return [data, isLoading];
};

export const useGetRoleOptions = () => {
  const isLoading = useApiLoading(c.ACL_ROLE_LIST, 'get');
  const data = useApiGet(c.ACL_ROLE_LIST, []);
  useEffect(() => {
    actions.getRoleOptions();
  }, []);
  return [data, isLoading];
};

export const useCreateACLUser = () => {
  const isLoading = useApiLoading(c.ACL_CREATE_USER, 'post');
  const submit = useCallback((payload, onSuccess, onError) => {
    actions.createACLUser(payload, onSuccess, onError);
  }, []);
  return [submit, isLoading];
};

export const useUpdateACLUser = () => {
  const isLoading = useApiLoading(c.ACL_UPDATE_USER, 'put');
  const update = useCallback((id, payload, onSuccess, onError) => {
    actions.updateUser(id, payload, onSuccess, onError);
  }, []);
  return [update, isLoading];
};

export const useSelectedUser = (id) => {
  const isLoading = useApiLoading(c.ACL_SELECTED_USER, 'get');
  const data = useApiGet(c.ACL_SELECTED_USER, {});
  useEffect(() => {
    actions.selectedUser(id);
  }, [id]);
  return [data, isLoading];
};

export const useDeleteUser = () => {
  const isLoading = useApiLoading(c.ACL_DELETE_USER, 'remove');
  const deleteUser = useCallback((id, onSuccess) => {
    actions.deleteUser(id, onSuccess);
  }, []);
  return [deleteUser, isLoading];
};

export const useMfaToggleAllUsers = () => {
  const isLoading = useApiLoading(c.ACL_MFA_TOGGLE_ALL_USERS, 'put');
  const toggle = useCallback((status, onSuccess) => {
    actions.mfaToggleAllUsers(status, onSuccess);
  }, []);
  return [toggle, isLoading];
};

export const useChangePassword = () => {
  const isLoading = useApiLoading(c.ACL_CHANGE_PASSWORD, 'post');
  return [actions.changePassword, isLoading];
};
